(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-local-storage.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/shared/hooks/use-local-storage.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useState = _React.useState,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useRef = _React.useRef;
const useLocalStorage = function (key, domain) {
  let initialValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  let expirationTimeMinutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  const _useState = useState(initialValue),
    _useState2 = _slicedToArray(_useState, 2),
    storedValue = _useState2[0],
    setStoredValue = _useState2[1];
  const mounted = useRef(false);
  const loadStoredValue = async () => {
    svs.components.Storage.browser.get(key, domain, value => {
      if (mounted.current) {
        setStoredValue(value || initialValue);
      }
    });
  };
  useEffect(() => {
    mounted.current = true;
    loadStoredValue();
    return () => {
      mounted.current = false;
    };
  }, []);
  useEffect(() => {
    loadStoredValue();
  }, [key, domain]);
  const setValue = useCallback(function (value) {
    let cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setStoredValue(storedValue => {
      const valueToStore = typeof value === 'function' ? value(storedValue) : value;
      svs.components.Storage.browser.set(key, domain, valueToStore, expirationTimeMinutes, cb);
      return valueToStore;
    });
  }, [key, domain, expirationTimeMinutes]);
  const clearValue = useCallback(() => {
    svs.components.Storage.browser.remove(key, domain);
    setStoredValue(initialValue);
  }, [key, domain, initialValue]);
  const clearStorage = () => {
    svs.components.Storage.browser.remove(key, domain);
  };
  return [storedValue, setValue, clearValue, clearStorage];
};
setGlobal('svs.eInstant.shared.hooks.useLocalStorage', useLocalStorage);

 })(window);